module.exports = __webpack_public_path__ + "img/site_visit.fc0c00e0.svg";